import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { useRestaurant } from '../context/RestaurantContext';
import { useNavigate } from 'react-router-dom';
import { HiOutlineArrowRightEndOnRectangle, HiOutlineXMark, HiOutlineChevronLeft, HiOutlineChevronRight, HiOutlineMagnifyingGlass, HiOutlineArrowDownTray, HiOutlineTrash, HiOutlinePencil, HiOutlineUserCircle, HiOutlineUsers } from 'react-icons/hi2';
import toast from 'react-hot-toast';
import XLSX from 'xlsx-js-style';
import api from '../utils/api';
import '../styles/auth.css';
import '../styles/dashboard.css';

const SD=['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
const HR12=['01','02','03','04','05','06','07','08','09','10','11','12'];
const MNS=['00','30'];
const to24=(h,m,ap)=>{if(!h||!m||!ap)return'';let hr=parseInt(h);if(ap==='AM'&&hr===12)hr=0;else if(ap==='PM'&&hr!==12)hr+=12;return`${hr.toString().padStart(2,'0')}:${m}`;};
const to12=t=>{if(!t)return{h:'',m:'',ap:'AM'};const[hr,mn]=t.split(':').map(Number);const ap=hr>=12?'PM':'AM';let h=hr%12;if(h===0)h=12;return{h:h.toString().padStart(2,'0'),m:mn.toString().padStart(2,'0'),ap};};
const d12=t=>{if(!t)return'';const{h,m,ap}=to12(t);return`${h}:${m} ${ap}`;};
const gM=(o=0)=>{const d=new Date();d.setDate(d.getDate()-(d.getDay()||7)+1+o*7);d.setHours(0,0,0,0);return d;};
const gW=m=>Array.from({length:7},(_,i)=>{const d=new Date(m);d.setDate(m.getDate()+i);return d;});
const fd=d=>{const y=d.getFullYear();const m=String(d.getMonth()+1).padStart(2,'0');const dd=String(d.getDate()).padStart(2,'0');return `${y}-${m}-${dd}`;};
const fp=d=>`${d.getDate()} ${d.toLocaleString('en',{month:'short'})}`;
const cH=(a,b)=>{if(!a||!b)return 0;const[h1,m1]=a.split(':').map(Number);const[h2,m2]=b.split(':').map(Number);let m=(h2*60+m2)-(h1*60+m1);if(m<0)m+=1440;return m/60;};
const fH=h=>{const r=Math.floor(h);const m=Math.round((h-r)*60);return m>0?`${r}h ${m}m`:`${r}h`;};
const fP=a=>`£${a.toFixed(2)}`;
const ini=n=>n?.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2)||'?';

const SearchBar=({value,onChange,placeholder})=>(
  <div style={{position:'relative',marginBottom:14}}>
    <HiOutlineMagnifyingGlass style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',color:'var(--text-light)',pointerEvents:'none'}} size={18}/>
    <input
      value={value}
      onChange={e=>onChange(e.target.value)}
      placeholder={placeholder}
      style={{width:'100%',padding:'12px 40px 12px 42px',border:'1.5px solid var(--border-strong)',borderRadius:'var(--r)',fontFamily:'var(--font)',fontSize:14,background:'var(--surface)',color:'var(--text)',outline:'none',transition:'border-color 0.15s, box-shadow 0.15s'}}
      onFocus={e=>{e.target.style.borderColor='var(--blue-500)';e.target.style.boxShadow='var(--ring-blue)';}}
      onBlur={e=>{e.target.style.borderColor='var(--border-strong)';e.target.style.boxShadow='none';}}
    />
    {value&&(
      <button onClick={()=>onChange('')} style={{position:'absolute',right:10,top:'50%',transform:'translateY(-50%)',background:'none',border:'none',cursor:'pointer',color:'var(--text-muted)',padding:4,display:'flex'}} title="Clear">
        <HiOutlineXMark size={16}/>
      </button>
    )}
  </div>
);

const TP=({value,onChange,label})=>{
  const p=value?to12(value):{h:'',m:'',ap:'AM'};
  const[h,setH]=useState(p.h);const[m,setM]=useState(p.m);const[ap,setAp]=useState(p.ap);
  useEffect(()=>{const x=to12(value);setH(x.h);setM(x.m);setAp(x.ap);},[value]);
  const up=(nh,nm,na)=>{if(nh&&nm&&na)onChange(to24(nh,nm,na));else onChange('');};
  return(<div><label style={{fontSize:11,color:'var(--text2)',fontWeight:600,display:'block',marginBottom:4}}>{label}</label><div style={{display:'flex',gap:3}}>
    <select value={h} onChange={e=>{setH(e.target.value);up(e.target.value,m||'00',ap);}} style={{flex:1,padding:'8px 2px',border:'1.5px solid var(--border)',borderRadius:8,fontSize:13,outline:'none',fontFamily:'var(--font)',background:'var(--card)',color:'var(--text)',fontWeight:600,textAlign:'center'}}><option value="">HH</option>{HR12.map(v=><option key={v} value={v}>{v}</option>)}</select>
    <span style={{display:'flex',alignItems:'center',fontWeight:700,color:'var(--text3)',fontSize:13}}>:</span>
    <select value={m} onChange={e=>{setM(e.target.value);up(h||'12',e.target.value,ap);}} style={{flex:1,padding:'8px 2px',border:'1.5px solid var(--border)',borderRadius:8,fontSize:13,outline:'none',fontFamily:'var(--font)',background:'var(--card)',color:'var(--text)',fontWeight:600,textAlign:'center'}}><option value="">MM</option>{MNS.map(v=><option key={v} value={v}>{v}</option>)}</select>
    <select value={ap} onChange={e=>{setAp(e.target.value);up(h||'12',m||'00',e.target.value);}} style={{flex:1,padding:'8px 2px',border:'1.5px solid var(--border)',borderRadius:8,fontSize:13,outline:'none',fontFamily:'var(--font)',background:ap==='AM'?'var(--green3)':'#eff6ff',color:ap==='AM'?'var(--green)':'#2563eb',fontWeight:700,textAlign:'center'}}><option value="AM">AM</option><option value="PM">PM</option></select>
  </div></div>);
};

const Confirm=({show,icon,title,desc,onOk,onCancel})=>{
  if(!show)return null;
  return(<div className="confirm-overlay"><div className="confirm-box"><div className="confirm-icon">{icon||'⚠️'}</div><div className="confirm-title">{title}</div><div className="confirm-desc">{desc}</div><div className="confirm-btns"><button className="confirm-cancel" onClick={onCancel}>Cancel</button><button className="confirm-ok" onClick={onOk}>Confirm</button></div></div></div>);
};

// Skeleton helpers — render a pulsing gray bar
const Skel=({w,h=14,r=4,style={}})=><span className="skeleton-pulse" style={{display:'inline-block',width:w,height:h,background:'#e5e7eb',borderRadius:r,...style}}/>;

export default function Dashboard(){
  const{user,logout,isOwnerOrManager,isOwner}=useAuth();
  const{activeRestaurant}=useRestaurant();
  const isAdmin = isOwnerOrManager;
  const isOwnerOnly = isOwner;
  const nav=useNavigate();
  const[emps,setEmps]=useState([]);
  const[shifts,setShifts]=useState([]);
  const[wOff,setWOff]=useState(0);
  const[tabSearch,setTabSearch]=useState('');
  const[loading,setLoading]=useState(true);
  const[mob,setMob]=useState(window.innerWidth<768);
  const[showShift,setShowShift]=useState(null);
  const[showExport,setShowExport]=useState(false);
  const[showChangePw,setShowChangePw]=useState(false);
  const[shiftForm,setShiftForm]=useState({clockIn:'',clockOut:'',notes:''});
  const[shiftLd,setShiftLd]=useState(false);
  const[expStart,setExpStart]=useState('');
  const[expEnd,setExpEnd]=useState('');
  const[expLd,setExpLd]=useState(false);
  const[pwForm,setPwForm]=useState({current:'',new:''});
  const[pwLd,setPwLd]=useState(false);
  const[pending,setPending]=useState([]);
  const[allUsers,setAllUsers]=useState([]);
  const[tab,setTab]=useState('calendar');
  const[actLd,setActLd]=useState('');
  const[confirm,setConfirm]=useState({show:false,icon:'',title:'',desc:'',action:null});

  const mon=gM(wOff);const wDates=gW(mon);const wStart=fd(wDates[0]);

  useEffect(()=>{const h=()=>setMob(window.innerWidth<768);window.addEventListener('resize',h);return()=>window.removeEventListener('resize',h);},[]);

  const fetchAll=useCallback(async()=>{
    try{
      const[eR,sR]=await Promise.all([api.get('/employees'),api.get(`/shifts/week?weekStart=${wStart}`)]);
      setEmps(eR.data.employees||[]);setShifts(sR.data.shifts||[]);
      if(isOwnerOnly){
        try{
          const params = activeRestaurant?._id ? { params: { restaurantId: activeRestaurant._id } } : {};
          const[p,a]=await Promise.all([
            api.get('/users/pending', params),
            api.get('/users', params)
          ]);
          setPending(p.data.users||[]);
          setAllUsers(a.data.users||[]);
        }catch{}
      }
    }catch{toast.error('Failed to load');}finally{setLoading(false);}
  },[wStart,isAdmin,isOwnerOnly,activeRestaurant?._id]);

  useEffect(()=>{fetchAll();},[fetchAll]);

  const askConfirm=(icon,title,desc,action)=>setConfirm({show:true,icon,title,desc,action});
  const doConfirm=()=>{if(confirm.action)confirm.action();setConfirm({show:false});};
  const cancelConfirm=()=>setConfirm({show:false});

  const switchTab=(t)=>{setTab(t);setTabSearch('');};

  const toggleEmp=(id,name,active)=>{askConfirm(active?'⏸':'▶',active?'Deactivate Employee':'Activate Employee',`${active?'Deactivate':'Activate'} ${name}? ${active?"They won't appear on the calendar.":'They will appear on the calendar again.'}`,async()=>{try{await api.put(`/employees/${id}/toggle`);toast.success('Done');fetchAll();}catch{toast.error('Failed');}});};
  const delEmp=(id,name)=>{askConfirm('🗑️','Delete Employee',`Permanently delete ${name}? This cannot be undone.`,async()=>{try{await api.delete(`/employees/${id}`);toast.success('Deleted');fetchAll();}catch{toast.error('Failed');}});};

  const saveShift=async()=>{setShiftLd(true);try{await api.post('/shifts',{employee:showShift.empId,date:showShift.date,...shiftForm});toast.success('Saved!');setShowShift(null);fetchAll();}catch(e){toast.error(e.response?.data?.message||'Failed');}finally{setShiftLd(false);}};
  const delShift=id=>{askConfirm('🗑️','Delete Shift','Delete this shift record? This cannot be undone.',async()=>{try{await api.delete(`/shifts/${id}`);toast.success('Deleted');setShowShift(null);fetchAll();}catch{toast.error('Failed');}});};

  const approveU=async(id,n)=>{setActLd(id);try{await api.put(`/admin/approve/${id}`);toast.success(`${n} approved`);fetchAll();}catch{toast.error('Failed');}finally{setActLd('');}};
  const rejectU=(id,n)=>{askConfirm('❌','Reject User',`Reject and remove ${n}? They will need to sign up again.`,async()=>{setActLd(id);try{await api.delete(`/admin/reject/${id}`);toast.success('Rejected');fetchAll();}catch{toast.error('Failed');}finally{setActLd('');}});};
  const toggleU=async(id)=>{setActLd(id);try{await api.put(`/admin/toggle-status/${id}`);toast.success('Changed');fetchAll();}catch{toast.error('Failed');}finally{setActLd('');}};
  const delU=(id,n)=>{askConfirm('🗑️','Delete User',`Permanently delete ${n}? This cannot be undone.`,async()=>{setActLd(id);try{await api.delete(`/admin/delete-user/${id}`);toast.success('Deleted');fetchAll();}catch{toast.error('Failed');}finally{setActLd('');}});};

  const changePw=async()=>{if(!pwForm.current||!pwForm.new){toast.error('Both fields required');return;}if(pwForm.new.length<6){toast.error('Min 6 characters');return;}setPwLd(true);try{await api.put('/auth/change-password',{currentPassword:pwForm.current,newPassword:pwForm.new});toast.success('Password changed!');setShowChangePw(false);setPwForm({current:'',new:''});}catch(e){toast.error(e.response?.data?.message||'Failed');}finally{setPwLd(false);}};

  const handleExport=async()=>{if(!expStart||!expEnd){toast.error('Select dates');return;}if(expStart>expEnd){toast.error('Invalid range');return;}setExpLd(true);try{const r=await api.get(`/shifts/export?startDate=${expStart}&endDate=${expEnd}`);const{summary,grandTotalHours,grandTotalPay}=r.data;const wb=XLSX.utils.book_new();const hs={font:{bold:true,color:{rgb:'FFFFFF'},sz:12},fill:{fgColor:{rgb:'0F2318'}},alignment:{horizontal:'center',vertical:'center',wrapText:true}};const ts={font:{bold:true,sz:16,color:{rgb:'0F2318'}},alignment:{horizontal:'center'}};const ss={font:{sz:11,color:{rgb:'4A6355'}},alignment:{horizontal:'center'}};const cs=e=>({font:{sz:11,color:{rgb:'1A2E23'}},fill:{fgColor:{rgb:e?'F0F5F2':'FFFFFF'}},alignment:{horizontal:'center',vertical:'center'},border:{bottom:{style:'thin',color:{rgb:'DCE8E0'}}}});const ns=e=>({...cs(e),font:{sz:11,bold:true,color:{rgb:'1A2E23'}},alignment:{horizontal:'left',vertical:'center'}});const ps=e=>({...cs(e),font:{sz:12,bold:true,color:{rgb:'059669'}}});const tr={font:{bold:true,sz:12,color:{rgb:'FFFFFF'}},fill:{fgColor:{rgb:'059669'}},alignment:{horizontal:'center',vertical:'center'}};const tp={...tr,font:{bold:true,sz:14,color:{rgb:'FFFFFF'}}};const hd=['Employee Name','Per Hour Rate (£)','Days Worked','Day Names','Total Hours','Net Pay (£)'];const d=[];d.push([{v:'Restaurant Employee Salary Report',s:ts},'','','','','']);d.push([{v:`Period: ${expStart} to ${expEnd}`,s:ss},'','','','','']);d.push(['','','','','','']);d.push(hd.map(h=>({v:h,s:hs})));summary.forEach((e,i)=>{const ev=i%2===0;d.push([{v:e.name,s:ns(ev)},{v:`£${e.ratePerHour}`,s:cs(ev)},{v:e.daysWorked,s:cs(ev)},{v:e.dayNames||'-',s:{...cs(ev),alignment:{horizontal:'left',vertical:'center',wrapText:true}}},{v:fH(e.totalHours),s:cs(ev)},{v:`£${e.totalPay.toFixed(2)}`,s:ps(ev)}]);});d.push([{v:'TOTAL',s:tr},{v:'',s:tr},{v:summary.reduce((s,e)=>s+e.daysWorked,0),s:tr},{v:'',s:tr},{v:fH(grandTotalHours),s:tr},{v:`£${grandTotalPay.toFixed(2)}`,s:tp}]);const ws=XLSX.utils.aoa_to_sheet(d);ws['!merges']=[{s:{r:0,c:0},e:{r:0,c:5}},{s:{r:1,c:0},e:{r:1,c:5}}];ws['!cols']=[{wch:24},{wch:18},{wch:14},{wch:32},{wch:16},{wch:16}];ws['!rows']=[{hpx:36},{hpx:24},{hpx:10},{hpx:32}];XLSX.utils.book_append_sheet(wb,ws,'Salary Report');XLSX.writeFile(wb,`Salary_${expStart}_to_${expEnd}.xlsx`);toast.success('Exported!');setShowExport(false);}catch{toast.error('Failed');}finally{setExpLd(false);}};

  const activeEmps=emps.filter(e=>e.isActive);
  const eS=id=>shifts.filter(s=>s.employee?._id===id||s.employee===id);
  const eH=id=>eS(id).reduce((s,sh)=>s+(sh.totalHours||0),0);
  const eP=e=>parseFloat((eH(e._id)*e.ratePerHour).toFixed(2));
  const dS=(eid,date)=>shifts.find(s=>(s.employee?._id===eid||s.employee===eid)&&s.date===date);
  const gH=activeEmps.reduce((s,e)=>s+eH(e._id),0);
  const gP=parseFloat(activeEmps.reduce((s,e)=>s+eP(e),0).toFixed(2));

  const ts=tabSearch.toLowerCase();
  const empsFiltered=emps.filter(e=>e.name.toLowerCase().includes(ts));
  const salaryEmpsFiltered=activeEmps.filter(e=>e.name.toLowerCase().includes(ts));
  const pendingFiltered=pending.filter(u=>u.name?.toLowerCase().includes(ts)||u.email?.toLowerCase().includes(ts));
  const allUsersFiltered=allUsers.filter(u=>u.name?.toLowerCase().includes(ts)||u.email?.toLowerCase().includes(ts));

  const openShift=(eid,date,ex)=>{setShiftForm({clockIn:ex?.clockIn||'',clockOut:ex?.clockOut||'',notes:ex?.notes||''});setShowShift({empId:eid,date,existing:ex});};

  const editEmployee=(e)=>{if(e.user){nav(`/users/${e.user}/edit`);}else{toast.error('This employee has no login account. Add one from the Users page.');}};

  // NOTE: removed the `if (loading) return <spinner>` block.
  // The dashboard now renders immediately with skeleton placeholders while data loads.

  const tabs=isOwnerOnly?['calendar','employees','salary','users']:isAdmin?['calendar','employees']:['calendar'];
  const ov = 'modal-overlay';
  const md = 'modal';

  return(<div className="dash">
    <Confirm show={confirm.show} icon={confirm.icon} title={confirm.title} desc={confirm.desc} onOk={doConfirm} onCancel={cancelConfirm}/>

    <nav className="nav">
      <div className="nav-left">
        <button
          onClick={()=>isOwner&&activeRestaurant&&nav('/restaurants')}
          title={isOwner?'Switch restaurant':''}
          style={{display:'flex',alignItems:'center',gap:10,background:'none',border:'none',padding:0,cursor:isOwner?'pointer':'default',font:'inherit',color:'inherit'}}
        >
          {activeRestaurant?.logo
            ? <img src={activeRestaurant.logo} alt={activeRestaurant.name} style={{width:36,height:36,borderRadius:9,objectFit:'cover',flexShrink:0}}/>
            : <div className="nav-logo">🍽️</div>
          }
          <span className="nav-title" style={{whiteSpace:'nowrap',overflow:'hidden',textOverflow:'ellipsis',maxWidth:200}}>
            {activeRestaurant?.name||'Dashboard'}
          </span>
        </button>
      </div>
      <div className="nav-tabs">
        {tabs.map(t=><button key={t} className={`nav-tab ${tab===t?'active':''}`} onClick={()=>switchTab(t)}>{t.charAt(0).toUpperCase()+t.slice(1)}{t==='users'&&pending.length>0&&<span className="nav-badge">{pending.length}</span>}</button>)}
      </div>
      <div className="nav-right">
        {isOwnerOnly&&<button className="btn g" onClick={()=>setShowExport(true)}><HiOutlineArrowDownTray/>{!mob&&' Export'}</button>}
        <button className="btn" onClick={()=>nav('/profile')} title="My profile"><HiOutlineUserCircle/></button>
        {!mob&&<div className="nav-avatar">{ini(user?.name)}</div>}
        <button className="btn r" onClick={()=>{logout();nav('/signin');}}><HiOutlineArrowRightEndOnRectangle/></button>
      </div>
    </nav>

    <div className="dash-body">
      <main className="main">
        {tab==='calendar'&&(<>
          <div className="cal-head">
            <div className="cal-nav">
              <button className="cal-arrow" onClick={()=>setWOff(w=>w-1)}><HiOutlineChevronLeft/></button>
              <div><div className="cal-title">{fp(wDates[0])} – {fp(wDates[6])}</div><div className="cal-subtitle">All Employees</div></div>
              <button className="cal-arrow" onClick={()=>setWOff(w=>w+1)}><HiOutlineChevronRight/></button>
              <button className="btn" onClick={()=>setWOff(0)} style={{fontSize:10}}>Today</button>
            </div>
           {isAdmin&&<div className="cal-stats">
              <div className="cal-stat">
                <div className="cal-stat-val g">{loading?<Skel w={60} h={18}/>:fP(gP)}</div>
                <div className="cal-stat-label">Pay</div>
              </div>
            </div>}
          </div>
          <div className="cal-wrap">
            <table className="cal-table">
              <thead><tr>
                <th className="ec" style={{width:mob?70:110}}>Employee</th>
                {wDates.map((d,i)=><th key={i}><div className="cal-dn">{SD[i]}</div><div className={`cal-dd ${fd(d)===fd(new Date())?'today':''}`}>{d.getDate()}</div></th>)}
              </tr></thead>
              <tbody>
                {loading ? (
                  // Skeleton rows: 5 placeholder rows pulsing while data loads
                  Array.from({length:5}).map((_,i)=>(
                    <tr key={`sk-${i}`}>
                      <td className="ec">
                        <div className="ce">
                          <div className="skeleton-pulse" style={{width:30,height:30,borderRadius:8,background:'#e5e7eb',flexShrink:0}}/>
                          <div style={{marginTop:4}}><Skel w={50} h={10}/></div>
                        </div>
                      </td>
                      {wDates.map((d,j)=>(
                        <td key={j} className={j>=5?'wk':''}>
                          <div className="skeleton-pulse" style={{background:'#f3f4f6',height:36,borderRadius:6,margin:'6px 4px'}}/>
                        </td>
                      ))}
                    </tr>
                  ))
                ) : (
                  activeEmps.map(e=>(
                    <tr key={e._id}>
                      <td className="ec"><div className="ce"><div className="ce-a" style={{background:e.color}}>{ini(e.name)}</div><div><div className="ce-n" style={{maxWidth:mob?45:70}}>{e.name}</div></div></div></td>
                      {wDates.map((d,i)=>{const ds=fd(d);const sh=dS(e._id,ds);return(
                        <td key={i} className={i>=5?'wk':''} onClick={()=>openShift(e._id,ds,sh)}>
                          {sh?(<div className="shift-block" style={{background:`${e.color}0d`,borderColor:`${e.color}20`,borderLeftColor:e.color}}>
                            <div className="shift-time" style={{color:e.color}}>{d12(sh.clockIn)}–{d12(sh.clockOut)}</div>
                            <div className="shift-hrs">{fH(sh.totalHours)}</div>
                            {isAdmin&&<div className="shift-pay" style={{color:'var(--green)'}}>{fP(sh.totalPay)}</div>}
                          </div>):(<div className="shift-empty">+</div>)}
                        </td>);})}
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </>)}

        {tab==='employees'&&(
          <div className="emp-section">
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:14,flexWrap:'wrap',gap:8}}>
              <h2 style={{fontSize:16,fontWeight:800,color:'var(--text)',margin:0}}>
                {loading?<Skel w={140} h={18}/>:`Employees (${empsFiltered.length}${tabSearch?` of ${emps.length}`:''})`}
              </h2>
              {isOwner&&<button className="btn g" onClick={()=>nav('/users')}><HiOutlineUsers/> Add Employees</button>}
            </div>
            <SearchBar value={tabSearch} onChange={setTabSearch} placeholder="Search employees by name..."/>
            {loading ? (
              <div className="emp-grid">
                {Array.from({length:4}).map((_,i)=>(
                  <div className="emp-card" key={`sk-${i}`}>
                    <div className="skeleton-pulse" style={{width:44,height:44,borderRadius:11,background:'#e5e7eb',flexShrink:0}}/>
                    <div className="emp-card-info" style={{flex:1}}>
                      <Skel w={110} h={14}/>
                      {isAdmin&&<div style={{marginTop:6}}><Skel w={70} h={11}/></div>}
                    </div>
                  </div>
                ))}
              </div>
            ) : empsFiltered.length===0 ? (
              <div className="empty"><div className="empty-icon">{tabSearch?'🔍':'👤'}</div><h3>{tabSearch?`No matches for "${tabSearch}"`:'No employees'}</h3></div>
            ) : (
              <div className="emp-grid">{empsFiltered.map(e=>(
                <div className={`emp-card ${e.isActive?'':'off'}`} key={e._id}>
                  <div className="emp-card-avatar" style={{background:e.color}}>{ini(e.name)}</div>
                  <div className="emp-card-info">
                    <div className="emp-card-name">{e.name}</div>
                    {isAdmin&&<div className="emp-card-rate">£{e.ratePerHour} / hour</div>}
                  </div>
                  {isAdmin&&<>
                    <span className={`emp-card-status ${e.isActive?'on':'off'}`}>{e.isActive?'Active':'Inactive'}</span>
                    <div className="emp-card-actions">
                      <button className="emp-card-btn" title="Edit on Users page" onClick={()=>editEmployee(e)}><HiOutlinePencil/></button>
                      <button className="emp-card-btn" title={e.isActive?'Deactivate':'Activate'} onClick={()=>toggleEmp(e._id,e.name,e.isActive)} style={{color:e.isActive?'var(--yellow)':'var(--green)'}}>{e.isActive?'⏸':'▶'}</button>
                      <button className="emp-card-btn r" title="Delete" onClick={()=>delEmp(e._id,e.name)}><HiOutlineTrash/></button>
                    </div>
                  </>}
                </div>
              ))}</div>
            )}
          </div>
        )}

        {tab==='salary'&&isOwnerOnly&&(
          <div className="emp-section">
            <div style={{display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:14,flexWrap:'wrap',gap:8}}>
              <div style={{display:'flex',alignItems:'center',gap:6}}>
                <button className="cal-arrow" onClick={()=>setWOff(w=>w-1)}><HiOutlineChevronLeft/></button>
                <h2 style={{fontSize:mob?13:16,fontWeight:800,color:'var(--text)',margin:0}}>{fp(wDates[0])} – {fp(wDates[6])}</h2>
                <button className="cal-arrow" onClick={()=>setWOff(w=>w+1)}><HiOutlineChevronRight/></button>
                <button className="btn" onClick={()=>setWOff(0)} style={{fontSize:10}}>Today</button>
              </div>
              <div className="cal-stats">
                <div className="cal-stat">
                  <div className="cal-stat-val g">{loading?<Skel w={60} h={18}/>:fP(gP)}</div>
                  <div className="cal-stat-label">Pay</div>
                </div>
              </div>
            </div>
            <SearchBar value={tabSearch} onChange={setTabSearch} placeholder="Search by employee name..."/>
            {loading ? (
              <div style={{overflowX:'auto'}}>
                <table className="sal-table">
                  <thead><tr><th style={{textAlign:'left'}}>Employee</th><th>Rate</th><th>Days</th><th>Hours</th><th>Pay</th></tr></thead>
                  <tbody>{Array.from({length:4}).map((_,i)=>(
                    <tr key={`sk-${i}`}>
                      <td><div style={{display:'flex',alignItems:'center',gap:7}}><div className="skeleton-pulse" style={{width:26,height:26,borderRadius:6,background:'#e5e7eb'}}/><Skel w={80}/></div></td>
                      <td style={{textAlign:'center'}}><Skel w={30}/></td>
                      <td style={{textAlign:'center'}}><Skel w={20}/></td>
                      <td style={{textAlign:'center'}}><Skel w={40}/></td>
                      <td style={{textAlign:'center'}}><Skel w={50}/></td>
                    </tr>
                  ))}</tbody>
                </table>
              </div>
            ) : salaryEmpsFiltered.length===0 ? (
              <div className="empty"><div className="empty-icon">🔍</div><h3>No matches for "{tabSearch}"</h3></div>
            ) : (
              <div style={{overflowX:'auto'}}>
                <table className="sal-table">
                  <thead><tr><th style={{textAlign:'left'}}>Employee</th><th>Rate</th><th>Days</th><th>Hours</th><th>Pay</th></tr></thead>
                  <tbody>{salaryEmpsFiltered.map(e=>{const h=eH(e._id);return(
                    <tr key={e._id}><td><div style={{display:'flex',alignItems:'center',gap:7}}><div style={{width:26,height:26,borderRadius:6,background:e.color,display:'flex',alignItems:'center',justifyContent:'center',color:'#fff',fontWeight:700,fontSize:9}}>{ini(e.name)}</div><span style={{fontWeight:600,fontSize:12}}>{e.name}</span></div></td><td style={{textAlign:'center',fontWeight:600}}>£{e.ratePerHour}</td><td style={{textAlign:'center'}}>{eS(e._id).length}</td><td style={{textAlign:'center',fontWeight:600}}>{fH(h)}</td><td style={{textAlign:'center',fontWeight:800,color:'var(--green)',fontSize:13}}>{fP(h*e.ratePerHour)}</td></tr>
                  );})}</tbody>
                </table>
              </div>
            )}
          </div>
        )}

        {tab==='users'&&isOwnerOnly&&(
          <div className="user-section">
            <SearchBar value={tabSearch} onChange={setTabSearch} placeholder="Search users by name or email..."/>
            {loading ? (
              <>
                <h2 style={{fontSize:16,fontWeight:800,color:'var(--text)',marginBottom:12}}><Skel w={140} h={18}/></h2>
                {Array.from({length:4}).map((_,i)=>(
                  <div className="user-card" key={`sk-${i}`}>
                    <div className="user-left">
                      <div className="skeleton-pulse" style={{width:42,height:42,borderRadius:11,background:'#e5e7eb',flexShrink:0}}/>
                      <div><Skel w={120}/><div style={{marginTop:5}}><Skel w={160} h={11}/></div></div>
                    </div>
                  </div>
                ))}
              </>
            ) : (
              <>
                {pendingFiltered.length>0&&<>
                  <h2 style={{fontSize:16,fontWeight:800,color:'var(--text)',marginBottom:12}}>Pending ({pendingFiltered.length}{tabSearch?` of ${pending.length}`:''})</h2>
                  {pendingFiltered.map(u=>(
                    <div className="user-card" key={u._id}><div className="user-left"><div className="user-av p">{ini(u.name)}</div><div><div className="user-name">{u.name}</div><div className="user-email">{u.email}</div></div></div><div className="user-right"><button className="abtn ap" onClick={()=>approveU(u._id,u.name)} disabled={actLd===u._id}>{actLd===u._id?'...':'✓ Approve'}</button><button className="abtn rj" onClick={()=>rejectU(u._id,u.name)} disabled={actLd===u._id}>{actLd===u._id?'...':'✕ Reject'}</button></div></div>
                  ))}
                </>}
                <h2 style={{fontSize:16,fontWeight:800,color:'var(--text)',marginTop:pendingFiltered.length>0?24:0,marginBottom:12}}>All Users ({allUsersFiltered.length}{tabSearch?` of ${allUsers.length}`:''})</h2>
                {allUsersFiltered.length===0?<div className="empty"><div className="empty-icon">{tabSearch?'🔍':'👥'}</div><h3>{tabSearch?`No matches for "${tabSearch}"`:'No users yet'}</h3></div>:allUsersFiltered.map(u=>(
                  <div className="user-card" key={u._id}><div className="user-left"><div className={`user-av ${u.isApproved?'a':'p'}`}>{ini(u.name)}</div><div><div className="user-name">{u.name}</div><div className="user-email">{u.email}</div></div></div><div className="user-right"><span className={`tag ${u.isApproved?(u.isActive?'a':'d'):'p'}`}>{u.isApproved?(u.isActive?'Active':'Deactivated'):'Pending'}</span>{u.isApproved&&<button className="abtn rj" onClick={()=>toggleU(u._id)} disabled={actLd===u._id}>{u.isActive?'Deactivate':'Activate'}</button>}<button className="abtn rj" onClick={()=>delU(u._id,u.name)} disabled={actLd===u._id} style={{color:'var(--red)'}}><HiOutlineTrash/></button></div></div>
                ))}
              </>
            )}
          </div>
        )}
      </main>
    </div>

    {showShift&&<div className={ov}><div className={md}>
      <div className="modal-head"><div><div className="modal-title">{showShift.existing?'Update Shift':'Log Shift'}</div><div className="modal-desc">{emps.find(e=>e._id===showShift.empId)?.name} — {showShift.date}</div></div><button className="modal-close" onClick={()=>setShowShift(null)}><HiOutlineXMark/></button></div>
      <div className="shift-box"><div className="shift-box-title">Working Hours</div><div className="shift-box-row"><div style={{flex:1}}><TP label="Clock In" value={shiftForm.clockIn} onChange={v=>setShiftForm(p=>({...p,clockIn:v}))}/></div><div style={{flex:1}}><TP label="Clock Out" value={shiftForm.clockOut} onChange={v=>setShiftForm(p=>({...p,clockOut:v}))}/></div></div>
        {shiftForm.clockIn&&shiftForm.clockOut&&(()=>{const h=cH(shiftForm.clockIn,shiftForm.clockOut);const e=emps.find(x=>x._id===showShift.empId);const p=e?h*e.ratePerHour:0;return<div className="shift-box-calc"><span className="shift-box-hrs">{fH(h)}</span>{isAdmin&&<span className="shift-box-pay">{fP(p)}</span>}</div>;})()}
      </div>
      <div className="field"><label>Notes (optional)</label><input value={shiftForm.notes} onChange={e=>setShiftForm(p=>({...p,notes:e.target.value}))} placeholder="e.g. Late"/></div>
      <div className="btn-row">{showShift.existing&&<button className="btn-del" onClick={()=>delShift(showShift.existing._id)}>Delete</button>}<button className="btn-save" onClick={saveShift} disabled={shiftLd}>{shiftLd?'Saving...':'Save'}</button></div>
    </div></div>}

    {showExport&&<div className={ov}><div className={md} style={{maxWidth:360}}><div className="modal-head"><div><div className="modal-title">Export Excel</div><div className="modal-desc">Colorful report, one row per employee</div></div><button className="modal-close" onClick={()=>setShowExport(false)}><HiOutlineXMark/></button></div><div className="field"><label>Start Date</label><input type="date" value={expStart} onChange={e=>setExpStart(e.target.value)}/></div><div className="field"><label>End Date</label><input type="date" value={expEnd} onChange={e=>setExpEnd(e.target.value)}/></div><button className="btn-save" style={{width:'100%'}} onClick={handleExport} disabled={expLd}>{expLd?'Exporting...':<><HiOutlineArrowDownTray/> Download</>}</button></div></div>}

    {showChangePw&&<div className={ov}><div className={md} style={{maxWidth:360}}><div className="modal-head"><div><div className="modal-title">Change Password</div></div><button className="modal-close" onClick={()=>setShowChangePw(false)}><HiOutlineXMark/></button></div><div className="field"><label>Current Password</label><input type="password" value={pwForm.current} onChange={e=>setPwForm(p=>({...p,current:e.target.value}))} placeholder="Enter current password"/></div><div className="field"><label>New Password</label><input type="password" value={pwForm.new} onChange={e=>setPwForm(p=>({...p,new:e.target.value}))} placeholder="Enter new password (min 6)"/></div><button className="btn-save" style={{width:'100%'}} onClick={changePw} disabled={pwLd}>{pwLd?'Changing...':'Change Password'}</button></div></div>}

    <style>{`
      @keyframes skeleton-pulse {
        0%, 100% { opacity: 1; }
        50% { opacity: 0.4; }
      }
      .skeleton-pulse {
        animation: skeleton-pulse 1.4s ease-in-out infinite;
        user-select: none;
      }

      @media (max-width: 768px) {
        .nav {
          height: 58px !important;
          padding: 0 14px !important;
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          right: 0 !important;
          z-index: 99 !important;
          background: var(--surface) !important;
        }
        .dash { padding-top: 58px !important; }
        .nav-tabs {
          position: fixed !important;
          bottom: 0 !important; left: 0 !important; right: 0 !important; top: auto !important;
          z-index: 100 !important;
          background: var(--surface) !important;
          border: none !important;
          border-top: 1px solid var(--border) !important;
          border-radius: 0 !important;
          padding: 6px 6px 10px !important;
          margin: 0 !important;
          height: 64px !important;
          display: flex !important;
          gap: 4px !important;
          box-shadow: 0 -4px 16px rgba(0,0,0,0.04) !important;
        }
        .nav-tab {
          flex: 1 !important;
          display: flex !important; flex-direction: column !important;
          align-items: center !important; justify-content: center !important;
          gap: 3px !important;
          padding: 6px 0 0 !important;
          background: transparent !important;
          border-radius: 0 !important;
          font-size: 10.5px !important;
          font-weight: 700 !important;
          color: var(--text-muted) !important;
          box-shadow: none !important;
          position: relative !important;
          letter-spacing: 0.02em;
          text-transform: capitalize;
        }
        .nav-tab.active {
          background: transparent !important;
          color: var(--blue-500) !important;
          font-weight: 800 !important;
        }
        .nav-tab.active::before {
          content: ''; position: absolute; top: 0; left: 30%; right: 30%;
          height: 3px; background: var(--blue-500); border-radius: 0 0 3px 3px;
        }
        .nav-tab::after {
          content: ''; width: 22px; height: 22px;
          background-position: center; background-repeat: no-repeat; background-size: contain;
          order: -1;
          filter: brightness(0) saturate(100%) invert(54%) sepia(11%) saturate(443%) hue-rotate(182deg) brightness(95%) contrast(86%);
        }
        .nav-tab.active::after {
          filter: brightness(0) saturate(100%) invert(28%) sepia(96%) saturate(2476%) hue-rotate(216deg) brightness(101%) contrast(101%);
        }
        .nav-tab:nth-child(1)::after {
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'><path d='M7 2a1 1 0 011 1v1h8V3a1 1 0 112 0v1h1a3 3 0 013 3v12a3 3 0 01-3 3H5a3 3 0 01-3-3V7a3 3 0 013-3h1V3a1 1 0 011-1zm13 8H4v9a1 1 0 001 1h14a1 1 0 001-1v-9zM8 14a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zm4 0a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zm4 0a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1z'/></svg>");
        }
        .nav-tab:nth-child(2)::after {
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'><path d='M12 12a5 5 0 100-10 5 5 0 000 10zM4 20.5C4 16.91 7.58 14 12 14s8 2.91 8 6.5a1.5 1.5 0 01-1.5 1.5h-13A1.5 1.5 0 014 20.5z'/></svg>");
        }
        .nav-tab:nth-child(3)::after {
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'><path d='M3 7a3 3 0 013-3h12a3 3 0 013 3v1h-2a4 4 0 100 8h2v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7zm19 3v4h-3a2 2 0 110-4h3zm-3 1.25a.75.75 0 100 1.5.75.75 0 000-1.5z'/></svg>");
        }
        .nav-tab:nth-child(4)::after {
          background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%23000'><path d='M9 11a4 4 0 100-8 4 4 0 000 8zm6.5-1a3.5 3.5 0 100-7 3.5 3.5 0 000 7zM2 19.5C2 15.91 5.13 13 9 13s7 2.91 7 6.5A1.5 1.5 0 0114.5 21h-11A1.5 1.5 0 012 19.5zm15.5 1.5a3 3 0 003-3c0-2.76-2.46-5-5.5-5-.85 0-1.65.18-2.36.5C13.91 14.18 15 16.71 15 19.5c0 .54-.14 1.05-.4 1.5h2.9z'/></svg>");
        }
        .nav-badge {
          position: absolute !important;
          top: 4px !important; right: 25% !important;
          background: var(--bad) !important;
          color: #fff !important;
          font-size: 9px !important; font-weight: 800 !important;
          min-width: 16px !important; height: 16px !important;
          border-radius: 8px !important;
          padding: 0 4px !important;
          border: 2px solid var(--surface) !important;
          display: flex !important; align-items: center !important; justify-content: center !important;
        }
        .main {
          -webkit-overflow-scrolling: touch !important;
          scroll-behavior: smooth !important;
          overflow-y: auto !important;
          padding-bottom: 16px !important;
        }
        .dash-body { padding-bottom: 80px !important; }
        .emp-section, .user-section {
          -webkit-overflow-scrolling: touch !important;
          padding-bottom: 24px !important;
        }
        .cal-wrap {
          -webkit-overflow-scrolling: touch !important;
          padding-right: 4px !important;
          padding-bottom: 100px !important;
          padding-left: 0 !important;
          padding-top: 0 !important;
        }
        .cal-table .ec {
          width: 80px !important; min-width: 80px !important; max-width: 80px !important;
          padding: 10px 6px !important;
          position: sticky !important; left: 0 !important;
          z-index: 5 !important;
          background: #fff !important;
          border-right: 1px solid var(--border) !important;
          box-shadow: 4px 0 8px -4px rgba(0, 0, 0, 0.06) !important;
        }
        .cal-table thead .ec {
          z-index: 10 !important;
          background: var(--paper-soft) !important;
          top: 0 !important;
        }
        .cal-table thead th:not(.ec) {
          position: sticky !important; top: 0 !important;
          z-index: 2 !important;
          background: var(--paper-soft) !important;
        }
        .ce {
          display: flex !important; flex-direction: column !important;
          align-items: center !important; justify-content: center !important;
          gap: 4px !important; width: 100% !important;
        }
        .ce-a {
          width: 30px !important; height: 30px !important;
          font-size: 11px !important; border-radius: 8px !important;
          flex-shrink: 0 !important;
        }
        .ce-n {
          font-size: 11px !important; font-weight: 700 !important;
          color: var(--text) !important; text-align: center !important;
          line-height: 1.15 !important;
          white-space: normal !important; word-break: break-word !important;
          max-width: 100% !important;
        }
        .cal-table td:not(.ec), .cal-table th:not(.ec) {
          min-width: calc((100vw - 80px - 4px) / 4) !important;
          width: calc((100vw - 80px - 4px) / 4) !important;
        }
        .cal-table tbody tr:last-child td {
          border-bottom: 1.5px solid var(--border) !important;
        }
      }
    `}</style>
  </div>);
}